import AxiosInterceptor from "api/interceptor";

const release = new AxiosInterceptor();

export default {
  getAllRelease() {
    return release.get("/release_note");
  }
};
